module.exports = require("core-js-pure/stable/reflect/construct");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/reflect/construct.js
// module id = 613
// module chunks = 0